var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub underline popover-hover"},[_c('div',{staticClass:"popover-nav"},[_vm._v("(說明)")]),_c('div',{staticClass:"popover"},[_c(_vm.renderMatchedComponent(_vm.paymentType),{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }